export const PRO_APP_DOWNLOAD_URL = 'https://app-pro.onelink.me/LjAU/appproinstall';
